import { AnimatePresence } from 'framer-motion';
import { FC, useEffect, useState } from 'react';
import { Control, useFormState } from 'react-hook-form';
import styled from 'styled-components';

import Text from '@/components/Text';

import { FormDataT } from '..';
import DetailsDrawer from './DetailsDrawer';

const DetailsButton = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 94px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  background: ${({ theme }) => theme.colors.white};
  gap: 8px;
  transition: 0.15s ease-out all;

  &:hover {
    color: ${({ theme }) => theme.colors.black};
    border-color: ${({ theme }) => theme.colors.gray};
  }
`;

interface Props {
  control: Control<FormDataT>;
  onSubmit: () => Promise<void>;
}

const Details: FC<Props> = ({ control, onSubmit }) => {
  const [showForm, setShowForm] = useState(false);

  const { errors } = useFormState<FormDataT>({ control });

  useEffect(() => {
    if (errors.watermark || errors.title) {
      setShowForm(true);
    }
  }, [errors.watermark, errors.title]);

  return (
    <>
      <DetailsButton
        $type="smallHeadline"
        $color="gray"
        as="button"
        onClick={() => setShowForm(true)}
      >
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.5 8.5C4.32843 8.5 5 7.82843 5 7C5 6.17157 4.32843 5.5 3.5 5.5C2.67157 5.5 2 6.17157 2 7C2 7.82843 2.67157 8.5 3.5 8.5ZM8 8.5C8.82843 8.5 9.5 7.82843 9.5 7C9.5 6.17157 8.82843 5.5 8 5.5C7.17157 5.5 6.5 6.17157 6.5 7C6.5 7.82843 7.17157 8.5 8 8.5ZM14 7C14 7.82843 13.3284 8.5 12.5 8.5C11.6716 8.5 11 7.82843 11 7C11 6.17157 11.6716 5.5 12.5 5.5C13.3284 5.5 14 6.17157 14 7Z"
            fill="currentColor"
          />
        </svg>
        Details
      </DetailsButton>
      <AnimatePresence>
        {showForm && (
          <DetailsDrawer
            control={control}
            onClose={() => setShowForm(false)}
            onSubmit={onSubmit}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default Details;
